import '../assests/css/common.css'

export const AboutUS = () => {
    return (
        <>
            <div className="service-detail-v1" >
                <h4>ABOUT US</h4>

                <hr className='font-family-class' style={{ margin: "auto", padding: "10px"}} />
                <p className='font-family-class' >
                    Taxify services, An accounting and tax consulting firm rendering comprehensive professional services which include audit, management consultancy, tax consultancy, accounting services, manpower management, secretarial services etc.
                    <br />
                    Taxify services. In is a professionally managed firm. The team consists of distinguished chartered accountants, company secretary, corporate financial advisors and tax consultants.
                </p>
            </div>
        </>
    )
};